module.exports = __webpack_public_path__ + "static/media/icon-Men.360c272e.svg";